import {
  Attribute,
  Directive,
  HostBinding,
  HostListener, Inject,
  Input
} from '@angular/core';
import { KeyCode } from '../../domain/key-code.enum';
import { HelpLinkService } from './help-link.service';

/**
 * The Help Link Directive
 *
 * Can be applied to link or a button to open help window
 */
@Directive({
  selector: '[tdWbHelpLink]',
  exportAs: 'tdWbHelpLink'
})
export class HelpLinkDirective {
  /**
   * The article id to be scrolled to in Help window
   */
  @Input('tdWbHelpLink') public articleId: string;

  @HostBinding('attr.href') hrefAttr: string;
  @HostBinding('attr.role') roleAttr: string;
  @HostBinding('attr.tabindex') tabindexAttr: string;

  constructor(@Attribute('role') private role: string | null,
              @Attribute('tabindex') tabIndex: string,
              @Inject(HelpLinkService) private helpLinkService: HelpLinkService) {
    this.hrefAttr = '';
    this.roleAttr = role !== null ? role : 'button';
    this.tabindexAttr = tabIndex !== null ? tabIndex : '0';
  }

  @HostListener('click', ['$event'])
  launchHelpWindow(event?: MouseEvent | KeyboardEvent): void {
    if (event !== undefined) {
      event.preventDefault();
    }
    this.helpLinkService.open(this.getArticleId());
  }

  // TODO: use a common base class to open window, href and this directive
  @HostListener('keydown', ['$event', '$event.key'])
  onKeyDown(event: KeyboardEvent, keyCode: string): void {
    if ((this.role === 'button' && (keyCode === KeyCode.ENTER || keyCode === KeyCode.SPACE)) ||
      (this.role === 'link' && keyCode === KeyCode.ENTER)) {
      this.launchHelpWindow(event);
    }
  }

  close(): void {
    this.helpLinkService.close();
  }

  /**
   * This getter is used for getting the help article id. If not specified as input, returns helpId from current route's data
   *
   * @returns Returns id passed to help link service.
   */
  getArticleId(): string {
    return this.articleId !== undefined && this.articleId.trim().length > 0
      ? this.articleId
      : this.helpLinkService.getHelpArticleId();
  }
}
